import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import SuperbuySpreadsheetGuide from "../pages/guide/superbuy-spreadsheet-101/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/guide/superbuy-spreadsheet-101",
    element: <SuperbuySpreadsheetGuide />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;